// Pages load when they are opened, not with the first screen (2026-10-27: the whole panel was one
// 3.5 MB file and the login screen stayed blank until all of it had downloaded from the server).
//
// lazyPage(() => import("@/pages/X")) is React.lazy plus one recovery: after a deploy the old page
// files are deleted from the server, so a browser still running the previous version cannot fetch
// them ("Loading chunk … failed"). The page then reloads once to pick up the new version; a second
// failure in a row is shown as an error instead of reloading for ever.
import { lazy } from "react";

const KEY = "novus.chunk-reload";

export function lazyPage(load) {
  return lazy(async () => {
    try {
      const mod = await load();
      try { sessionStorage.removeItem(KEY); } catch { /* storage blocked */ }
      return mod;
    } catch (e) {
      const chunkGone = /Loading (CSS )?chunk|ChunkLoadError|Failed to fetch dynamically imported module/i.test(`${e?.name} ${e?.message}`);
      let tried = false;
      try { tried = sessionStorage.getItem(KEY) === "1"; } catch { /* storage blocked */ }
      if (chunkGone && !tried) {
        try { sessionStorage.setItem(KEY, "1"); } catch { /* storage blocked */ }
        window.location.reload();
        return new Promise(() => {}); // keep the loader up while the page reloads
      }
      throw e;
    }
  });
}
